/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBattery3 = createReactComponent("battery-3", "IconBattery3", [
  [
    "path",
    {
      d: "M6 7h11a2 2 0 0 1 2 2v.5a.5 .5 0 0 0 .5 .5a.5 .5 0 0 1 .5 .5v3a.5 .5 0 0 1 -.5 .5a.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2",
      key: "svg-0"
    }
  ],
  ["path", { d: "M7 10l0 4", key: "svg-1" }],
  ["path", { d: "M10 10l0 4", key: "svg-2" }],
  ["path", { d: "M13 10l0 4", key: "svg-3" }]
]);

export { IconBattery3 as default };
//# sourceMappingURL=IconBattery3.js.map
